import { RiLinkM, RiQqFill, RiStarSmileFill, RiWeiboFill } from "react-icons/ri"
import { ShareModalStyle } from "./style"
import { share } from "utils/functions/common";
import copy from "copy-to-clipboard";
import { message } from "antd";

const ShareModal = ({ shareImage, userId }: { shareImage?: string, userId: number }) => {

    const toShare = (type: string) => {
        const url = `https://www.ggac.com/user/${userId}`
        if (type === 'copy') {
            copy(url)
            message.success("复制成功")
            return
        }
        share(type, "userHome", {}, url)
    }

    return <ShareModalStyle>
        <div className="wrap">
            {
                shareImage && <div className="qr-code">
                    <img src={shareImage} alt="" />
                    <div className="weixin-tip">分享给微信好友</div>
                </div>
            }
            <div className="down">
                <div className="item" onClick={() => toShare('copy')}>
                    <div className="icon">
                        <RiLinkM></RiLinkM>
                    </div>
                    <span>复制链接</span>
                </div>
                <div className="item" onClick={() => toShare('sina')}>
                    <div className="icon" style={{ background: 'rgb(194, 53, 47)' }}>
                        <RiWeiboFill></RiWeiboFill>
                    </div>
                    <span>新浪微博</span>
                </div>
                <div className="item" onClick={() => toShare('qq')}>
                    <div className="icon" style={{ background: 'rgb(110, 179, 234)' }}>
                        <RiQqFill></RiQqFill>
                    </div>
                    <span>QQ</span>
                </div>
                <div className="item">
                    <div className="icon" onClick={() => toShare('qzone')} style={{ background: 'rgb(241, 208, 96)' }}>
                        <RiStarSmileFill></RiStarSmileFill>
                    </div>
                    <span>QQ空间</span>
                </div>
            </div>
        </div>
    </ShareModalStyle>
}

export default ShareModal